import request from "@/common/request"
import { ItemDaVenda, Page, Promocao } from "@/models"
import { AxiosRequestConfig } from "axios"

const basePath = '/promocao'

export const findPagePromocoes = (params?: any, config?: AxiosRequestConfig): Promise<Page<Promocao>> =>
	request.get(`${basePath}/busca`, {params, ...config})

export const criarPromocao = (promocao: Promocao): Promise<Promocao> =>
	request.post(`${basePath}/criar`, promocao)

export const atualizarPromocao = (promocao: Promocao): Promise<Promocao> =>
	request.post(`${basePath}/atualizar/${promocao.id}`, promocao)

export const findDescontosProgressivosAplicaveisNaVenda = (lojaId: any, cpfOuCnpjCliente: string, itens: ItemDaVenda[], valorTotalLiquidoDosItens: any): Promise<Promocao[]> =>
	request.post(`${basePath}/descontos-progressivos/${lojaId}?cpfOuCnpjCliente=${cpfOuCnpjCliente}&valor=${valorTotalLiquidoDosItens}`, itens)

export const atualizaRelacaoVendaPromocao = (params: any): Promise<void> =>
	request.post(`${basePath}/venda`, params)

export const validarItensDaVendaParaPromocao = (promocaoId: any, itens: ItemDaVenda[]): Promise<string[]> =>
	request.post(`${basePath}/itens-aplicaveis/${promocaoId}`, itens)